import { useRef } from 'react';
import { useSelector } from 'react-redux';
import useAudioDevice from '../../hooks/useAudioDevice';

export default function CallAudioElements() {

    const loginDetails = useSelector((state) => state.toolbar.loginDetails) || {};
    const { isSip = false, params = {} } = loginDetails;
    const endBeep = params.hasOwnProperty("SIP_END_BEEP") && params["SIP_END_BEEP"] === "true" && (isSip === "true" || isSip === true)

    const ringAudio = useSelector((state) => state.toolbar.ringAudioSkinId);
    const beepAudo = useSelector((state) => state.toolbar.beepAudoSkinId);
    const callAudio = useSelector((state) => state.toolbar.callAudoSkinId);
    const ringAudioRef = useRef(null);
    const beepAudioRef = useRef(null)

    useAudioDevice(ringAudioRef, ringAudio);
    useAudioDevice(beepAudioRef, beepAudo);
    useAudioDevice({ current: window.callAudioElement }, callAudio);

    return isSip && <>
        <audio id="ringAudio" ref={ringAudioRef} loop={true} hidden={true} src={`${process.env.PUBLIC_URL}/assets/audio/ring.mp3`}></audio>
        <audio id="beepAudio" ref={beepAudioRef} hidden={true} src={`${process.env.PUBLIC_URL}/assets/audio/beep.mp3`}></audio>
        {endBeep && <audio id="endBeepAudio" hidden={true} src={`${process.env.PUBLIC_URL}/assets/audio/endBeep.wav`}></audio>}
    </>

}
